import { requiredLoginLevel } from 'utils/routes/requiredLoginLevel';
import { config } from 'api';
import { AuthenticationLevel } from 'auth';

import { verifyRequiredBetaFeatures } from 'utils/betaFeatures/verifyRequiredBetaFeatures';
import { BetaFeatures } from 'apps/checkout/consts';

export default [
  {
    path: 'checkout',
    isFeedbackPopupHidden: config.feedbackPopup.excludeLocations.includes('checkoutWalk'),
    indexRoute: {
      onEnterHandlers: [
        requiredLoginLevel(AuthenticationLevel.LOGGED_IN),
        verifyRequiredBetaFeatures([BetaFeatures.POST_CHECKOUT_SUMMARY_RAVEN]),
      ],
    },
    childRoutes: [
      {
        onEnterHandlers: [
          requiredLoginLevel(AuthenticationLevel.LOGGED_IN),
          verifyRequiredBetaFeatures([BetaFeatures.POST_CHECKOUT_SUMMARY_RAVEN]),
        ],
        childRoutes: [
          {
            path: 'confirmation',
            getComponent(location, callback) {
              import(/* webpackChunkName: "postorder" */'[theme-lib]/apps/checkout/containers/PostOrderCheckout')
                .then(component => callback(null, component.default));
            },
          },
        ],
      },
    ],
  },
];
